import { render, staticRenderFns } from "./EditProfil.vue?vue&type=template&id=13ed3daa&scoped=true"
import script from "./EditProfil.vue?vue&type=script&lang=js"
export * from "./EditProfil.vue?vue&type=script&lang=js"
import style0 from "./EditProfil.vue?vue&type=style&index=0&id=13ed3daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ed3daa",
  null
  
)

export default component.exports